import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Modal } from '@shared/components/modal-list/modal.model';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { CloseComponent } from '@shared/components/modal-list/utilities/icons/close/close.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'modal-unit',
  templateUrl: './modal-unit.component.html',
  styleUrl: './modal-unit.component.scss',
  imports: [CloseComponent, TranslateModule, CommonModule],
})
export class ModalUnitComponent implements OnChanges {
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true })
  dynamicContainer!: ViewContainerRef;
  @Input() modal!: Modal;

  constructor(
    private modalService: ModalService,
    private cdRef: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.dynamicContainer.clear();
    this.dynamicContainer.createComponent(changes['modal'].currentValue.component);
    Promise.resolve().then(() => this.cdRef.detectChanges());
  }

  close() {
    this.modalService.skip();
  }
}
